module.exports = __webpack_public_path__ + "static/img/20020 (2).51d422a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20020 (2).webp
// module id = xFtW
// module chunks = 14